import * as actionTypes from '../../types/reports';

const initialState = {
  isLoading: true,
  isLoadingPageConfig: true,
  error: false,
  viewTabs: [
    {
      code: 'chart',
      title: 'Chart',
      url: '/admin/reports/payments',
    },
    {
      code: 'table',
      title: 'Table',
      url: '/admin/reports/payments/table',
    },
  ],
  users: [],
  pageData: {},
  mainConfig: {},
  pageConfig: {},
  pageFilters: {},
  pageFilterType: '',
  pageFiltersQuery: null,
};

const updates = (state = initialState, action) => {
  switch (action.type) {
  case actionTypes.GET_MAIN_CONFIG: {
    return {
      ...state,
      error: false,
      isLoading: true,
    };
  }
  case actionTypes.GET_MAIN_CONFIG_SUCCESS: {
    return {
      ...state,
      mainConfig: action.data,
    };
  }
  case actionTypes.GET_MAIN_CONFIG_ERROR: {
    return {
      ...state,
      error: true,
      isLoading: false,
    };
  }

  case actionTypes.GET_PAGE_CONFIG: {
    return {
      ...state,
      isLoadingPageConfig: true,
      error: false,
      isLoading: true,
    };
  }
  case actionTypes.GET_PAGE_CONFIG_SUCCESS: {
    return {
      ...state,
      pageConfig: action.data,
      isLoadingPageConfig: false,
    };
  }
  case actionTypes.GET_PAGE_CONFIG_ERROR: {
    return {
      ...state,
      isLoadingPageConfig: false,
      error: true,
      isLoading: false,
    };
  }
  case actionTypes.SET_PAGE_DATA: {
    return {
      ...state,
      pageData: {
        ...state.pageData,
        ...action.payload,
      },
    };
  }
  case actionTypes.SET_PAGE_FILTERS: {
    return {
      ...state,
      pageFilters: action.payload,
    };
  }
  case actionTypes.SET_PAGE_FILTERS_TYPE: {
    return {
      ...state,
      pageFilterType: action.payload,
    };
  }
  case actionTypes.SET_PAGE_FILTERS_QUERY: {
    return {
      ...state,
      pageFiltersQuery: action.payload,
    };
  }

  case actionTypes.GET_USERS_LIST_SEARCH: {
    return {
      ...state,
      users: [],
    };
  }
  case actionTypes.GET_USERS_LIST_SEARCH_SUCCESS: {
    return {
      ...state,
      users: action.data,
    };
  }
  case actionTypes.GET_USERS_LIST_SEARCH_ERROR: {
    return {
      ...state,
      users: [],
    };
  }

  case actionTypes.SET_PAGE_LOADER: {
    return {
      ...state,
      isLoading: action.payload,
    };
  }
  case actionTypes.SET_PAGE_CLEAR_PAGE_DATA: {
    return {
      ...state,
      pageData: {},
    };
  }
  default: {
    break;
  }
  }

  return state;
};

export default updates;
